import { z } from 'zod';
import {
  longTextSchema,
  projectIdSchema,
  tagsSchema,
  visibilitySchema,
} from './common.js';

export const tipInputSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'タイトルを入力してください')
    .max(100, 'タイトルは100文字以内'),
  body: longTextSchema(4000, '本文').refine(
    (v) => v.trim().length > 0,
    '本文を入力してください',
  ),
  tags: tagsSchema,
  visibility: visibilitySchema,
  projectId: projectIdSchema,
});

export type TipInputSchema = z.infer<typeof tipInputSchema>;
